import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFab } from "@/components/landing/WhatsAppFab";
import { BOOK_PERIO_PATH } from "@/components/landing/data";

export const BlogLayout = ({ children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, [children]);
  return (
    <div className="App grain bg-[#FCFBF7] min-h-screen">
      <header className="sticky top-0 z-40 px-4 sm:px-8 pt-4">
        <div className="mx-auto max-w-[1400px] flex items-center justify-between rounded-full px-4 sm:px-6 py-3 bg-[#FCFBF7]/85 backdrop-blur-xl border border-[#1B3B28]/10">
          <Link to="/" data-testid="blog-home-link"><Logo /></Link>
          <nav className="flex items-center gap-2">
            <Link to="/igiene-gbt" className="hidden sm:block px-4 py-2 text-sm text-[#1E2922]/80 hover:text-[#1B3B28]" data-testid="layout-gbt-link">Igiene GBT</Link>
            <Link to="/blog" className="hidden sm:block px-4 py-2 text-sm text-[#1E2922]/80 hover:text-[#1B3B28]" data-testid="blog-index-link">Blog</Link>
            <Link to={BOOK_PERIO_PATH} data-testid="blog-cta-booking" className="group flex items-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] pl-4 pr-2 py-2 text-sm hover:bg-[#3E6B48] transition-colors whitespace-nowrap">
              Prenota
              <span className="grid place-items-center w-7 h-7 rounded-full bg-[#86C89B] text-[#0F2317] transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight size={15} /></span>
            </Link>
          </nav>
        </div>
      </header>
      <main>{children}</main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
};
